<template>
  <div class="content-1">
    <h3>{{ transPeralbaPro.item813 }}</h3>
    <h5>{{ transPeralbaPro.item814 }} <strong>{{ email }}</strong>.</h5>
    <h5><strong>{{ transPeralbaPro.item815 }}</strong></h5>

    <button
      type="button"
      :disabled="disabledForm"
      class="btn-per-dark-outlined mt-4"
      @click="volverInicioSesion"
    >{{ transPeralbaPro.item812 }}</button>
  </div>
</template>
<script>
export default {
  props: ["email", "disabledForm", "transPeralbaPro"],
  methods: {
    volverInicioSesion(e) {
      this.$emit("showFirst", true);
      this.$emit("changeView", 1);
    },
  },
};
</script>
